import {getLanguage, getRegion, parseAndSanitizeJSONWithSpaces} from '../utils/utils'

/**
 * Custom hook to handle Gigya redirect logic.
 */
const useManuals = () => {
    const handleLanguage = (language, country) => {
        if (!language) return
        return `${language.charAt(0).toUpperCase()}${language.slice(1)} (${country})`
    }

    const extractLocales = (data = []) => {
        const result = []

        data?.forEach(({language}) => {
            const languageId = language != 'x-default' ? language : 'en'
            const languageKey = getLanguage(languageId.split('-')[0])
            const country = languageId.split('-')?.[1]
            const countryLabel = country ? getRegion(languageId, country) : 'International'

            result.push({
                locale: languageId,
                label: handleLanguage(languageKey, countryLabel),
            })
        })

        return result || []
    }

    const getProductManualsAllLanguages = (product) =>
        product?.c_manualDocumentAllCountry
            ? parseAndSanitizeJSONWithSpaces(product?.c_manualDocumentAllCountry)
            : []

    const getLanguageOptions = (product) => {
        if (!product) return []

        const productManualsAllLanguages = getProductManualsAllLanguages(product)

        const languageOptionsWithDefaults = extractLocales(productManualsAllLanguages).map(
            ({locale, label}) => ({
                label,
                value: {locale},
            }),
        )

        return (
            languageOptionsWithDefaults.filter(
                (obj, index, self) => index === self.findIndex((el) => el.label === obj.label),
            ) || []
        )
    }

    const getProductManualsInLanguage = (product, selectedLanguage) => {
        if (!product) return []
        const productManualsAllLanguages = getProductManualsAllLanguages(product)

        return productManualsAllLanguages?.find((manuals) => manuals.language === selectedLanguage)
    }

    return {getLanguageOptions, getProductManualsInLanguage}
}

export default useManuals
